import axios from 'axios'
import { CATALOGO_ENDPOINT } from '../../endpoints'
import * as FileSaver from 'file-saver'
import { XML_TYPE } from 'Utilities';

export async function postFileToUpdatePublishPrices(carLotId,bussinessUnitType,file){
  const formData = new FormData();
  formData.append('file',file)
  formData.append('carlotid',carLotId)
  formData.append('type',bussinessUnitType)
  const response = await axios.post(`${CATALOGO_ENDPOINT}/uploadPublishPriceFile`,formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },      
      responseType: 'blob',
      timeout: 300000 // 5 minutos
    })
  if (response) {
    const fileDownload = new Blob([response.data], {
      type: XML_TYPE
    })
    FileSaver.saveAs(fileDownload, 'DetalledeimportacionPublicaciones')
  }
  return response
}